import { getLocale } from '@/utils/locale'
import { store } from '@/store/index'

export function getBaseUrl() {
  var selectedlocale = getLocale()
  if (selectedlocale === undefined || selectedlocale == null) {
    selectedlocale = process.env.VUE_APP_I18N_LOCALE
  }
  const url_domain = store.state.url_domain
  const baseURL = '/' + selectedlocale + '/' + url_domain
  return baseURL
}

export function getParameter() {
  const url_store = store.state.selected_outlet.url_id
  let parameter = {}
  if (url_store) {
    parameter = {
      url_id: url_store
    }
  }
  return parameter
}
